import { createSlice } from '@reduxjs/toolkit';
import type { ExploreDetailsState } from './types';

const initialState: ExploreDetailsState = {
  isLoading: false,
  error: false,
  topics: [],
  pathway: null,
  index: 0,
  step: 200
};

export const slice = createSlice({
  name: 'exploreDetails',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    getPathwayTopics(state, action) {
      state.isLoading = false;
      state.topics = action.payload;
    },
    markTopicAsRead(state, action) {
      state.isLoading = false;
      const topic = state.topics.find((item) => item.guid === action.payload);
      if (topic) topic.isFollowing = true;
    },
    markTopicAsUnread(state, action) {
      state.isLoading = false;
      const topic = state.topics.find((item) => item.guid === action.payload);
      if (topic) topic.isFollowing = false;
    },
    markResourceAsRead(state, _action) {
      state.isLoading = false;
    },
    markResourceAsUnread(state, _action) {
      state.isLoading = false;
    },
    cleanPathway(state) {
      state.pathway = null;
    },
    getPathwaySuccess(state, action) {
      state.isLoading = false;
      state.pathway = action.payload;
    },
    // https://stackoverflow.com/questions/60465636/update-object-key-using-destructuring
    updatePathwayFollowed(state, action) {
      state.isLoading = false;
      if (state.pathway != null) {
        state.pathway.followed = action.payload;
      }
    }
  }
});

// Reducer
export default slice.reducer;
